import AppDatePicker from '@nxsys/components/AppDatePicker';
import AppFormContainer from '@nxsys/components/AppFormContainer';
import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Form } from 'antd';
import { FormProps } from 'antd/lib';
import moment, { Moment } from 'moment';
import React, { useEffect } from 'react';

type GenerateInvoiceModalProps = {
  isOpen: boolean;
  toggle: () => void;
  onGenerate: (values: GenerateInvoiceModalValues) => void;
  isGenerateInvoicePending: boolean;
};

export type GenerateInvoiceModalValues = {
  invoicedDate: Moment;
  dueDate: Moment;
};

const GenerateInvoiceModal: React.FC<GenerateInvoiceModalProps> = ({
  isOpen,
  toggle,
  onGenerate,
  isGenerateInvoicePending,
}: GenerateInvoiceModalProps) => {
  const { messages } = useTypedIntl();

  const [form] = Form.useForm<GenerateInvoiceModalValues>();

  // Default both dates to today each time the modal opens
  useEffect(() => {
    if (isOpen) {
      form.setFieldsValue({
        invoicedDate: moment(),
        dueDate: moment(),
      });
    }
  }, [isOpen, form]);

  const onFinish: FormProps['onFinish'] = (values) => {
    onGenerate(values);
  };

  const onFinishFailed: FormProps['onFinishFailed'] = (errorInfo) => {
    console.trace('Failed:', errorInfo);
  };

  return (
    <AppModalContainer
      title={messages['common.selectInvoiceDate']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.confirm'],
          buttonType: 'primary',
          onClick: () => form.submit(),
          loading: isGenerateInvoicePending,
          disabled: isGenerateInvoicePending,
        },
      ]}
      minHeight="200px"
    >
      <AppFormContainer
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="vertical"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        initialValues={{
          invoicedDate: moment(),
          dueDate: moment(),
        }}
      >
        <Form.Item
          name="invoicedDate"
          label={messages['form.invoicedDate']}
          rules={[
            {
              required: true,
              message: messages['form.pleaseSelect'],
            },
          ]}
        >
          <AppDatePicker
            placeholder={messages['form.select']}
            format={'DD/MM/YYYY'}
          />
        </Form.Item>

        <Form.Item
          name="dueDate"
          label={messages['common.dueDate']}
          rules={[
            {
              required: true,
              message: messages['form.pleaseSelect'],
            },
          ]}
        >
          <AppDatePicker
            placeholder={messages['form.select']}
            format={'DD/MM/YYYY'}
          />
        </Form.Item>
      </AppFormContainer>
    </AppModalContainer>
  );
};

export default GenerateInvoiceModal;
